module.exports = __webpack_public_path__ + "img/footer-providers-m.80a11a14.png";